import React from 'react';
import PropTypes from 'prop-types';

import './ShowLessToggle.less';

export default function ShowLessToggle({ showMoreShowLess, isOptionExpanded, apiKeyName }) {
  return (
    <span
      className="more-options"
      onClick={() => {
        showMoreShowLess(apiKeyName);
      }}
    >
      Show {!isOptionExpanded ? 'All' : 'Less'}
    </span>
  );
}

ShowLessToggle.propTypes = {
  isOptionExpanded: PropTypes.bool,
  showMoreShowLess: PropTypes.func,
  apiKeyName: PropTypes.string,
};
